// @flow

import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import { customValidators } from "../../utils/validators";
import useAsyncState from "../../hooks/useAsyncState";
import { changePassword } from "../../actions/user";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import Button from "../atoms/Button";

const ChangePasswordForm = (): React.Node => {
    const dispatch = useDispatch();
    const [state, localActions] = useAsyncState();
    const { isOktaUser } = useSelector((state: any): any => state.user);

    const handleFormSubmit = formData => {
        localActions.request();

        dispatch(
            changePassword(formData.current_password, formData.new_password)
        )
            .then(res => {
                localActions.success();
            })
            .catch((error: any) => {
                console.error(error);
                localActions.fail(
                    error.message ||
                        "There was an issue updating your password."
                );
            });
    };

    if (isOktaUser) {
        return null;
    }

    return (
        <ReactForm
            className="form-inset"
            validators={customValidators}
            onSuccess={handleFormSubmit}
        >
            <h3 className="login-profile-body__content__title">
                Change password
            </h3>

            <ServerErrorMessage>{state.error}</ServerErrorMessage>

            <ReactFormField
                type="password"
                label="Old password"
                name="current_password"
                validators={["utspassword"]}
                required={true}
            />

            <ReactFormField
                type="password"
                label="New password"
                name="new_password"
                validators={["utspassword"]}
                required={true}
            />

            <Button
                type="submit"
                styles={["green"]}
                inline={true}
                aria-label="Save"
                loading={state.loading}
                success={!!state.success}
            >
                Save
            </Button>
        </ReactForm>
    );
};

export default ChangePasswordForm;
